/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUserMini
 */
export interface ElementsUserMini {
    /**
     * 
     * @type {number}
     * @memberof ElementsUserMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMini
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMini
     */
    readonly displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMini
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMini
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserMini
     */
    isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserMini
     */
    isCloud?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMini
     */
    username: string;
}

export function ElementsUserMiniFromJSON(json: any): ElementsUserMini {
    return ElementsUserMiniFromJSONTyped(json, false);
}

export function ElementsUserMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'displayName': json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'username': json['username'],
    };
}

export function ElementsUserMiniToJSON(value?: ElementsUserMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'avatar': value.avatar,
        'email': value.email,
        'full_name': value.fullName,
        'is_external': value.isExternal,
        'is_cloud': value.isCloud,
        'username': value.username,
    };
}


